/** Countries the missions event-report endpoint accepts. */
export const MISSION_COUNTRIES = ['Djibouti', 'Haiti', 'Mauritanie', 'Congo', 'Liban', 'Senegal'];

/** The list spelling when `value` matches one of them, otherwise empty. */
export function missionCountry(value) {
  const text = String(value || '').trim().toLowerCase();
  return MISSION_COUNTRIES.find((name) => name.toLowerCase() === text) || '';
}
